var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-steps',{staticClass:"isStyleBase",attrs:{"active":_vm.active - 1,"align-center":"","space":"30%"}},_vm._l((_vm.list),function(step,$index){return _c('el-step',{key:$index + 1,attrs:{"title":step.title}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }